import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	emptyStateHeader: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	emptyStateDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	viewAllProjects: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	emptyStateHeaderGalaxia: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	emptyStateDescriptionGalaxia: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	viewAllProjectsGalaxia: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	emptyStateHeader: {
		id: 'deep-dive-cards-section.empty-state.empty-state-header',
		defaultMessage: 'No projects found',
		description: 'The header of the empty state in the deep dive card',
	},
	emptyStateDescription: {
		id: 'deep-dive-cards-section.empty-state.empty-state-description',
		defaultMessage: 'You have no recently viewed projects',
		description:
			'The message indicates users have no recently viewed projects in the dep dive card',
	},
	viewAllProjects: {
		id: 'deep-dive-cards-section.empty-state.view-all-projects',
		defaultMessage: 'View all projects',
		description: 'The message on the button to view all projects',
	},
	emptyStateHeaderGalaxia: {
		id: 'deep-dive-cards-section.empty-state.empty-state-header-galaxia',
		defaultMessage: 'No spaces found',
		description: 'The header of the empty state in the deep dive card',
	},
	emptyStateDescriptionGalaxia: {
		id: 'deep-dive-cards-section.empty-state.empty-state-description-galaxia',
		defaultMessage: 'You have no recently viewed spaces',
		description:
			'The message indicates users have no recently viewed projects in the dep dive card',
	},
	viewAllProjectsGalaxia: {
		id: 'deep-dive-cards-section.empty-state.view-all-projects-galaxia',
		defaultMessage: 'View all spaces',
		description: 'The message on the button to view all projects',
	},
});
export default messages;
